<script setup>

import { computed, toRaw } from 'vue'
import { getI18n } from '@/plugins/i18n'

import DxSelectBox from 'devextreme-vue/select-box'

import { usePortalStore } from '@/stores/portal.store.js'
import { useWebSiteStore } from '@/stores/web-site.store.js'

const props = defineProps({
  inverted: {
    type: Boolean,
    default: false,
  }
})

const portalStore = usePortalStore()
const websiteStore = useWebSiteStore()
const i18n = getI18n()

const languages = computed(() => {
  return toRaw(portalStore.languages).map((item) => {
    return {
      id: item.code,
      name: i18n.t(item.name)
    }
  })
})

const onLanguageValueChanged = async (e) => {
  if (websiteStore.user) {
    await websiteStore.updateOwnUserDetailsAsync({ preferred_language: e.value })
  }
  await portalStore.setLanguageAsync(e.value)
  portalStore.incrementReloadKey()
}

</script>
<template>
  <dx-select-box
    id="languageSelector"
    :class="{'inverted': props.inverted}"
    label-mode="hidden"
    value-expr="id"
    display-expr="name"
    :value="portalStore.selectedLanguage"
    :data-source="languages"
    @value-changed="onLanguageValueChanged"
  />
</template>
<style lang="scss">
  #languageSelector {
    &.inverted {
      & input,
      & select {
          color: white !important;
          -webkit-text-fill-color: white !important;
      }

      input.dx-texteditor-input {
        color: white !important;
      }

      &.dx-state-hover {
        background-color: transparent !important;
        color: red !important;
      }

      &.dx-editor-underlined:after {
        content: none !important;
        border-bottom: none !important;
      }

      & .dx-dropdowneditor-icon {
        color: white !important;
      }
    }
  }
</style>
